module.exports = __webpack_public_path__ + "img/Einheit_der_Bundeswehr.0967f2ae.svg";